import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import { GREAT_WHITE } from 'HubStyleTokens/colors';
import UIModal from 'UIComponents/dialog/UIModal';
import Big from 'UIComponents/elements/Big';
import H3 from 'UIComponents/elements/headings/H3';
import UIToolBar from 'UIComponents/nav/UIToolBar';
import UIToolBarGroup from 'UIComponents/nav/UIToolBarGroup';
import UILink from 'UIComponents/link/UILink';
import { TEMPLATE_TYPES } from 'knowledge-content-ui/constants/ChooseTemplateConstants';
import BackButton from './BackButton';
import ChangeTemplateLoading from './ChangeTemplateLoading';
import TemplatePickerPanel from './TemplatePickerPanel';
import { useState } from 'react';
import UIButton from 'UIComponents/button/UIButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Header = styled(UIToolBar).withConfig({
  displayName: "ChangeTemplatePage__Header",
  componentId: "sc-1mtp8v2-0"
})(["border-bottom:2px solid ", ";position:relative;box-shadow:0 2px 0 rgba(216,216,216,0.3);display:flex;min-height:72px;height:72px;padding:16px 26px;"], GREAT_WHITE);
const ScrollableContainer = styled.div.withConfig({
  displayName: "ChangeTemplatePage__ScrollableContainer",
  componentId: "sc-1mtp8v2-1"
})(["overflow-y:auto;"]);
const I18N_PREFIX = 'knowledgeContentUI.chooseTemplate.changeTemplatePage';
const ChangeTemplatePage = ({
  currentTemplate,
  onBackClick,
  onChooseTemplateClick,
  showLoadingOverlay
}) => {
  const [stagedTemplate, setStagedTemplate] = useState(currentTemplate);
  return /*#__PURE__*/_jsxs(UIModal, {
    use: "fullscreen",
    "data-test-id": "change-template-modal",
    children: [showLoadingOverlay && /*#__PURE__*/_jsx(ChangeTemplateLoading, {}), /*#__PURE__*/_jsxs(Header, {
      use: "tabs",
      children: [/*#__PURE__*/_jsx(UIToolBarGroup, {
        children: /*#__PURE__*/_jsx(BackButton, {
          children: /*#__PURE__*/_jsx(UILink, {
            onClick: onBackClick,
            children: /*#__PURE__*/_jsx(Big, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: `${I18N_PREFIX}.backButtonLabel`
              })
            })
          })
        })
      }), /*#__PURE__*/_jsx(UIToolBarGroup, {
        children: /*#__PURE__*/_jsx(H3, {
          className: "m-bottom-0",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `${I18N_PREFIX}.header`
          })
        })
      }), /*#__PURE__*/_jsx(UIToolBarGroup, {
        children: /*#__PURE__*/_jsx(UIButton, {
          "data-test-id": "save-template-button",
          use: "primary",
          onClick: () => onChooseTemplateClick(stagedTemplate),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `${I18N_PREFIX}.saveButtonLabel`
          })
        })
      })]
    }), /*#__PURE__*/_jsx(ScrollableContainer, {
      children: /*#__PURE__*/_jsx(TemplatePickerPanel, {
        className: "p-all-14",
        currentTemplate: stagedTemplate,
        onChooseTemplateClick: setStagedTemplate
      })
    })]
  });
};
ChangeTemplatePage.propTypes = {
  currentTemplate: PropTypes.oneOf(TEMPLATE_TYPES).isRequired,
  onBackClick: PropTypes.func.isRequired,
  onChooseTemplateClick: PropTypes.func.isRequired,
  showLoadingOverlay: PropTypes.bool.isRequired
};
export default ChangeTemplatePage;